import { IGenerateParametersParams } from './types'

export const generateParameters = ({ avatarUUID, identifiers }: IGenerateParametersParams): string => {
  const params = new URLSearchParams()

  if (identifiers.length === 1) {
    params.append('identifier', identifiers[0])
  } else {
    identifiers.forEach(identifier => params.append('identifiers', identifier))
  }

  if (avatarUUID) {
    params.append('avatar_uuid', avatarUUID)
  }

  return params.toString()
}
